import {
  Button,
  Card,
  CardContent,
  FormHelperText,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { ArrowUpward } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import { setUpgradeRequested } from "../../store/actions/dataActions";

const CurrentPlan = () => {
  const currentSession = useSelector((state) => state.sessions.currentSession);
  const [showImage, setShowImage] = useState(false);

  const {
    monthly_restart: uTierRestartInt,
    title: uTierTitle,
    interval: uTierInterval,
  } = useSelector(
    (state) => state[currentSession]?.user?.tier || {},
    shallowEqual
  );

  const { has_trial: uHasTrial } = useSelector(
    (state) => state[currentSession]?.user?.trial || {},
    shallowEqual
  );

  const navigate = useNavigate();
  const dispatch = useDispatch();

  const between905and1125 = useMediaQuery(
    "(min-width:900px) and (max-width:1125px)"
  );
  const between1200and1405 = useMediaQuery(
    "(min-width:1200px) and (max-width:1405px)"
  );
  const between1400and1700 = useMediaQuery(
    "(min-width:1400px) and (max-width:1700px)"
  );
  const miniSize = useMediaQuery("(max-width:330px)");
  const mobileSize = useMediaQuery((theme) => theme.breakpoints.down("sm"));
  const tabletSize = useMediaQuery((theme) => theme.breakpoints.down("md"));

  useEffect(() => {
    if (
      (!between905and1125 && !miniSize) ||
      (!between1400and1700 && uTierRestartInt) ||
      (uTierRestartInt && !between1400and1700)
    ) {
      setShowImage(true);
    } else {
      setShowImage(false);
    }
  }, [between1400and1700, between905and1125, miniSize, uTierRestartInt]);

  return (
    <Card
      className="step25"
      sx={{ minHeight: tabletSize ? undefined : "12.7rem" }}
    >
      <CardContent
        sx={{
          px: tabletSize ? 1.5 : between1200and1405 ? 1 : undefined,
          pt: mobileSize ? 1.5 : tabletSize ? 3 : undefined,
          pb: tabletSize ? 1.5 : undefined,
        }}
      >
        <Stack
          alignItems="flex-start"
          direction="row"
          justifyContent={tabletSize ? "center" : "space-between"}
          spacing={3}
        >
          <Stack spacing={1}>
            <Typography
              color="text.secondary"
              variant={tabletSize ? "h5" : "overline"}
            >
              Current Plan
            </Typography>
            <Typography variant="h6" sx={{ pb: 0, mb: 0, mt: 0, pt: 0 }}>
              {uTierTitle}
            </Typography>
            <FormHelperText
              sx={{
                fontSize: "14px",
                pt: 0,
                mt: 0,
                pb: 0,
                mb: 0,
                lineHeight: "4px",
              }}
            >
              {uHasTrial
                ? "Trial subscription"
                : uTierTitle === "Free"
                ? "Free subscription"
                : `${
                    uTierInterval?.charAt(0).toUpperCase() +
                    uTierInterval?.slice(1)
                  }ly subscription`}
            </FormHelperText>
            <FormHelperText
              sx={{ fontSize: "14px", pt: 0, mt: 0, lineHeight: "40px" }}
            >
              {/* {startPeriod && endPeriod ? `${startPeriod} - ${endPeriod}` : ""} */}
            </FormHelperText>
          </Stack>
          {showImage && (
            <Stack>
              <img
                alt="noc-form"
                src={
                  uHasTrial
                    ? "/img/dashboard/trialIcon.jpeg"
                    : "/img/dashboard/currentPlan.png"
                }
                style={{
                  maxWidth: mobileSize
                    ? "6rem"
                    : between1200and1405
                    ? "5.5rem"
                    : "6.5rem",
                  height: "auto",
                  margin: 0,
                }}
              />
            </Stack>
          )}
        </Stack>
        {uTierRestartInt && !currentSession !== "subUserSession" && (
          <Button
            onClick={() => {
              dispatch(setUpgradeRequested(true));
              navigate("/subscription");
            }}
            variant="contained"
            color="success"
            endIcon={<ArrowUpward />}
          >
            Upgrade
          </Button>
        )}
      </CardContent>
    </Card>
  );
};

export default React.memo(CurrentPlan);
